import { useConfiguration } from "@src/api/configurations/use-configuration";

/**
 * The same per-org toggle the backend gates every Agentic Logic read on
 * (`ConfigProvider.isAgenticLogicEnabled`). Read it here rather than adding a
 * separate flagg flag: if the UI and the serving gate could disagree, a
 * merchant could attach a rule the checkout surface would never consult.
 *
 * Outside React (thunks), read the same toggle through
 * `getIsAgenticLogicEnabled` in `store/slices/organization/selectors`.
 */
export const useIsAgenticLogicEnabled = (): boolean =>
  !!useConfiguration<boolean>("agentic_logic_enabled")?.value;
